import { Component } from 'react'
import PropTypes from 'prop-types'
import TextField from '../../Nodes/TextField'
import Button from '../../Nodes/Button'
import { H4, Body2 } from '../../Nodes/Typography'
import Dialog from '../../Widgets/Dialog'
import { AUTH_URL } from '../../../utilities/constants'
import { graphqlFetch } from '../../../utilities'

class Login extends Component {
    state = {
        loginButtonText: 'Login',
        loginButtonDisabled: false,
        username: undefined,
        password: undefined,
        error: undefined
    }    

    disableLoginButton = () => this.setState({ loginButtonText: 'Logging in...', loginButtonDisabled: true })
    enableLoginButton = () => this.setState({ loginButtonText: 'Login', loginButtonDisabled: false })
    setLoginError = (error) => this.setState({ error })

    validateInputs = () => {
        const valid = this.state.username && this.state.password
        if (!valid)
            this.setLoginError('Both the username and password fields are required.')
        return valid
    }

    handleUsernameInput = (e) => this.setState({ error: undefined, username: e.target.value })
    handlePasswordInput = (e) => this.setState({ error: undefined, password: e.target.value })
    handleLogin = async (e) => {        
        e && e.preventDefault()
        if (this.validateInputs()) {
            this.disableLoginButton()

            const res = await graphqlFetch('auth', `
                mutation {
                    login(
                        username: "${this.state.username}",
                        password: "${this.state.password}",
                        product: "Discovery Digest"
                    )
                }`)
            
            res.errors && res.errors.length > 0 ?
                this.setLoginError(res.errors[0].message) : // error
                this.props.setUser() // success

            this.enableLoginButton()
        }
    }

    onLoginResponse = (response) => {
        const callbacks = {
            200: this.props.setUser,
            400: this.onBadRequest,
            412: () => this.setLoginError('Invalid username or password.'),
            500: () => this.setLoginError('There is currently an issue with our servers. Please try again later.'),
            default: () => this.setLoginError('There is currently an issue with our login servers. Please try again later.'),
        }

        const callback = callbacks[response.status] || callbacks.default
        callback()
        this.enableLoginButton()
    }

    onLoginErrorResponse = (error) => {
        if (typeof error === 'object')
            this.onLoginResponse(error.response)
        else {
            this.setLoginError('We are having issues connecting to our servers. Please check your internet connection.')
            this.enableLoginButton()
        }
    }

    onBadRequest = () => {
        if (this.validateInputs())
            this.setLoginError('There is no account registered with that username.')
    }

    render() {        
        return (
            <Dialog
                className="login"
                open={this.props.open}
                onClose={this.props.onClose}>
                <div className="login__content style-hyperlink">
                    <section className="login__content__section">
                        <H4>Login</H4>
                        <form onSubmit={this.handleLogin}>
                            { this.state.error ? <Body2 className="login__error_text" dangerouslySetInnerHTML={{ __html: this.state.error}} /> : null }
                            <TextField
                                label="Username"
                                id="username"
                                value={this.state.username}
                                onInput={this.handleUsernameInput}
                                required />
                            <TextField
                                label="Password"
                                type="password"
                                id="password"
                                value={this.state.password}
                                onInput={this.handlePasswordInput}
                                required /><br />
                            <div className="login__button-container">
                                <Button raised disabled={this.state.loginButtonDisabled}>{this.state.loginButtonText}</Button>
                            </div>
                        </form>
                        <a href={AUTH_URL + '/Register'} target="_blank" rel="noreferrer">Create&nbsp;New&nbsp;Account</a><br />
                        <a href={AUTH_URL + '/RecoverAccount'} target="_blank" rel="noreferrer">Recover&nbsp;Account</a><br />
                    </section>
                    <section className="login__content__section hide-phone hide-tablet">
                        <H4>Don't Yet Have a Login?</H4>
                        <ul>
                            <li><b>Existing Client –</b><a href={AUTH_URL + '/Register'}>Create a User Account</a> now.</li>
                            <li><b>Not Yet a Client? –</b><a href="/about">View subscription details</a> and request information.</li>
                            <li><b>Not Sure? –</b> Many E&amp;P, service and financial organizations already subscribe. <a href="/contact">Contact us</a> to confirm your company’s status.</li>
                        </ul>
                    </section>
                </div>
            </Dialog>
        )
    }
}

Login.propTypes = {
    setUser: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
}

export default Login